import { FC } from 'react';
import { cn } from '@/shared/lib';
import { StreamingToken } from './StreamingToken';
import { Markdown } from '@ibsys/kit';

type Props = {
  tokens: string[];
  className?: string;
};

export const StreamingText: FC<Props> = ({ tokens, className }) => (
  <span className={cn('whitespace-pre-wrap', className)}>
    <Markdown>{tokens.slice(0, tokens.length - 1).join('')}</Markdown>
    {/* key={index} is safe here: tokens is append-only during streaming */}
    {tokens.slice(-1).map((token, index) => (
      <StreamingToken key={index} token={token} />
    ))}
  </span>
);
